<template>
  <v-main v-if="$store.state.details">
    <v-container class="fill-height" fluid>
      <v-row>
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      </v-row>
      <v-row class="px-2">
        <v-col cols="8" class="py-0">
          <v-tabs>
            <v-tab>Details</v-tab>
            <v-tab>Contacts</v-tab>
            <v-tab-item>
              <v-card class="px-4 pt-4 mt-4 grey lighten-5">
                <v-row>
                  <v-col cols="8" class="py-0">
                    <v-text-field outlined background-color="white" readonly
                      dense label="Client" v-model="$store.state.details.title" />
                  </v-col>
                  <v-col cols="4" class="py-0">
                    <v-text-field outlined background-color="white" readonly
                      dense label="Jobs sent by" v-model="$store.state.details.sendBy" />
                  </v-col>
                </v-row>
                <v-row class="pt-5">
                  <v-col cols="4" class="py-0">
                    <v-text-field outlined background-color="white" readonly
                      dense label="Phone" v-model="$store.state.details.phone" />
                  </v-col>
                  <v-col cols="4" class="py-0">
                    <v-text-field outlined background-color="white" readonly
                      dense label="Fax" v-model="$store.state.details.fax" />
                  </v-col>
                  <v-col cols="4" class="py-0">
                    <v-text-field outlined background-color="white" readonly
                      dense label="Mobile" v-model="$store.state.details.mobile" />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="py-0">
                    <v-text-field outlined background-color="white" readonly
                      dense label="Email" v-model="$store.state.details.email" />
                  </v-col>
                </v-row>
                <v-row class="pt-5">
                  <v-col cols="12" class="py-0">
                    <v-text-field outlined background-color="white" readonly
                      dense label="Address" v-model="$store.state.details.address" />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" class="py-0">
                    <v-text-field outlined background-color="white" readonly
                      dense label="Suburb" v-model="$store.state.details.suburb" />
                  </v-col>
                  <v-col cols="3" class="py-0">
                    <v-autocomplete
                      :items="['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA', 'NZ']"
                      v-model="$store.state.details.state" outlined background-color="white"
                      readonly dense label="State" />
                  </v-col>
                  <v-col cols="3" class="py-0">
                    <v-text-field outlined background-color="white" readonly
                      dense label="Postcode" v-model="$store.state.details.postcode" />
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card class="px-4 py-2 mt-4">
                <v-data-table
                  :headers="contactsTableHeaders"
                  :items="$store.state.details.contacts.items"
                  :search="contactsFilter"
                >
                  <template v-slot:item.deactivated="{ item }">
                    <v-checkbox v-model="item.deactivated" readonly />
                  </template>
                  <!-- <template v-slot:top>
                    <v-toolbar flat dense class="my-4">
                      <v-text-field v-model="contactsFilter" append-icon="mdi-magnify"
                      placeholder="Search" class="mt-2" />
                      <v-spacer />
                      <v-spacer />
                    </v-toolbar>
                  </template> -->
                </v-data-table>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>
<script>
export default {
  data() {
    return {
      breadcrumbs: [
        {
          text: 'Dashboard',
          to: '/',
          exact: true,
        },
        {
          text: 'My Details',
          disabled: true,
        },
      ],
      contactsTableHeaders: [
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Position',
          value: 'position',
        },
        {
          text: 'Phone',
          value: 'phone',
        },
        {
          text: 'Mobile',
          value: 'mobile',
        },
        {
          text: 'Fax',
          value: 'fax',
        },
        {
          text: 'Email',
          value: 'email',
        },
        {
          text: 'Deactivated',
          value: 'deactivated',
        },
      ],
      contactsFilter: null,
    };
  },
};
</script>
